import type { Announcement, AnnouncementType } from 'common/models';
import dayjs from 'dayjs';

import { getNow } from './timeHelpers';

export const getAnnouncementTypeTranslateKey = (type: AnnouncementType | string) => `type_${type}`;

export const getVisibleAnnouncements = (announcements: Announcement[]) => {
  return announcements.filter(
    (x) => dayjs.utc(x.showFrom).isBefore(getNow()) && dayjs.utc(x.showTo).isAfter(getNow())
  );
};
